export const DEMO_COMPANY_NAME = "Nenda Demo";
export function isDemoCompanyName(name) {
    return name === DEMO_COMPANY_NAME;
}
